// components/client/PostBoost.jsx
import React from 'react';
import { ArrowLeft, Share2 } from 'lucide-react';

export default function PostBoost({ onBack }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-orange-950 to-slate-950 p-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <button onClick={onBack} className="w-12 h-12 rounded-xl bg-white/10 hover:bg-white/20 transition-all flex items-center justify-center">
            <ArrowLeft className="w-6 h-6 text-white" />
          </button>
          <div>
            <h2 className="text-3xl font-bold text-white">Boost & Partage</h2>
            <p className="text-orange-200">Fonctionnalité en développement</p>
          </div>
        </div>
        
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-12 text-center">
          <Share2 className="w-24 h-24 text-orange-400 mx-auto mb-6" />
          <h3 className="text-2xl font-bold text-white mb-4">Bientôt disponible</h3>
          <p className="text-orange-200">Le partage automatique dans les groupes sera disponible prochainement.</p>
        </div>
      </div>
    </div>
  );
}